import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  margin-top: ${theme.spacing(2)};
  justify-content: space-evenly;
`;
